import * as React from "react"
const RPG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={33}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="m26.473 8.103 1.304 1.303 2.687-6.719-6.718 2.688 1.303 1.303-2.446 2.446c-7.095-6.222-17.267-3.83-17.71-3.749l-1.304.35.672 2.606 1.062-.268 9.178 9.164-4.274 4.273H7.621l-4.032 4.031 2.688 1.344 1.344 2.688 4.03-4.032v-2.607l4.274-4.273 9.164 9.178-.255 1.062 2.593.672.35-1.304c.08-.443 2.472-10.616-3.75-17.71l2.446-2.446ZM6.95 7.767c2.754-.376 9.11-.672 13.746 3.265l-5.254 5.254-8.492-8.52Zm18.436 18.436-8.52-8.492 5.255-5.254c3.937 4.636 3.641 10.991 3.265 13.746Z"
    />
  </svg>
)
export default RPG